module.exports = {
  ENTRY: 'entry',
  MID: 'mid',
  SENIOR: 'senior',
};
